import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
import { SearchBar } from '../components/SearchBar';
import { RestaurantCard } from '../components/RestaurantCard';
import { mockRestaurants } from '../utils/mockData';
import { SearchX } from 'lucide-react';
interface SearchResultsPageProps {
  query: string;
  onSearch: (query: string) => void;
  onSelectRestaurant: (id: string) => void;
}
export function SearchResultsPage({
  query,
  onSearch,
  onSelectRestaurant
}: SearchResultsPageProps) {
  const results = useMemo(() => {
    const lowerQuery = query.toLowerCase();
    return mockRestaurants.filter(r => r.name.toLowerCase().includes(lowerQuery) || r.cuisine.toLowerCase().includes(lowerQuery));
  }, [query]);
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="max-w-5xl mx-auto px-4 py-8 min-h-[80vh]" data-id="element-257">
      <div className="mb-8" data-id="element-258">
        <SearchBar initialQuery={query} onSearch={onSearch} data-id="element-259" />
      </div>

      <div className="flex flex-wrap items-center justify-between gap-4 mb-8" data-id="element-260">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-261">
          Results for "{query}"
        </h1>
        <div className="flex gap-2" data-id="element-262">
          <span className="inline-flex items-center px-3 py-1 rounded-full bg-white border border-slate-200 text-sm font-medium text-slate-600 shadow-sm" data-id="element-263">
            {results.length} found
          </span>
        </div>
      </div>

      {results.length > 0 ? <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-264">
          {results.map((restaurant, idx) => <RestaurantCard key={restaurant.id} restaurant={restaurant} onClick={onSelectRestaurant} index={idx} data-id="element-265" />)}
        </div> : <div className="text-center py-20 bg-white rounded-2xl border border-slate-200 shadow-sm" data-id="element-266">
          <SearchX className="w-16 h-16 text-slate-300 mx-auto mb-4" data-id="element-267" />
          <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-268">
            No restaurants found
          </h3>
          <p className="text-slate-500 max-w-md mx-auto" data-id="element-269">
            We couldn't find any matches for "{query}". Try searching for a
            different name or cuisine type like "Italian" or "Mexican".
          </p>
        </div>}
    </motion.div>;
}